(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    

(function () {
  const regions = new Set();
  const update = (region) => {
    const overflowing = region.scrollWidth > region.clientWidth + 1;
    region.toggleAttribute('tabindex', overflowing);
    if (overflowing) region.tabIndex = 0;
    region.nextElementSibling.hidden = !overflowing;
  };
  const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver((entries) => {
    entries.forEach(({target}) => update(target));
  });
  const init = (root) => {
    root.querySelectorAll('[data-article-content]').forEach((content) => {
      content.querySelectorAll('table').forEach((table) => {
        if (table.dataset.mcTableReady) return;
        table.dataset.mcTableReady = 'true';
        const block = document.createElement('div');
        block.className = 'mc-table-block';
        const region = document.createElement('div');
        region.className = 'mc-table-scroll';
        region.setAttribute('role', 'region');
        const label = table.caption?.textContent.trim() || content.dataset.tableLabel;
        region.setAttribute('aria-label', label);
        const hint = document.createElement('p');
        hint.className = 'mc-table-hint';
        hint.textContent = content.dataset.tableHint;
        hint.hidden = true;
        const columns = Math.max(1, ...Array.from(table.rows, (row) =>
          Array.from(row.cells).reduce((sum, cell) => sum + cell.colSpan, 0)
        ));
        table.style.setProperty('--mc-table-columns', columns);
        table.before(block);
        if (table.caption) {
          const caption = document.createElement('p');
          caption.className = 'mc-table-caption';
          caption.textContent = table.caption.textContent;
          caption.setAttribute('aria-hidden', 'true');
          block.append(caption);
        }
        block.append(region, hint);
        region.append(table);
        regions.add(region);
        if (observer) observer.observe(region);
        update(region);
      });
    });
  };
  const updateAll = () => regions.forEach((region) => {
    if (region.isConnected) update(region);
    else {
      observer?.unobserve(region);
      regions.delete(region);
    }
  });
  init(document);
  document.fonts?.ready.then(updateAll);
  window.addEventListener('resize', updateAll, {passive: true});
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    regions.forEach((region) => {
      if (!event.target.contains(region)) return;
      observer?.unobserve(region);
      regions.delete(region);
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
